import { render } from "./CreateCompany.vue?vue&type=template&id=571b77f8"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Companies/CreateCompany.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "571b77f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('571b77f8', __exports__)) {
    api.reload('571b77f8', __exports__)
  }
  
  module.hot.accept("./CreateCompany.vue?vue&type=template&id=571b77f8", () => {
    api.rerender('571b77f8', render)
  })

}


export default __exports__